import React from "react";
import TextField from "@material-ui/core/TextField";

export interface PercentInputProps {
  name: string;
  value?: string;
  onChange: (e: any) => void;
}

const PercentInput = (props: PercentInputProps) => {
  const [value, setValue] = React.useState(props.value);
  const [error, setError] = React.useState<string | undefined>();

  React.useEffect(() => {
    setValue(props.value);
    setError(undefined);
  }, [props.value]);

  const onChange = (e: any) => {
    const newValue = e.target.value;
    setValue(newValue);
    
    // Validate percentage
    if (newValue !== "" && !isNaN(newValue)) {
      const num = parseFloat(newValue);
      if (num < 0 || num > 100) {
        setError("Must be between 0 and 100");
      } else {
        setError(undefined);
      }
    } else if (newValue !== "") {
      setError("Must be a number");
    } else {
      setError(undefined);
    }
    
    props.onChange(e);
  };

  return (
    <>
      <TextField
        autoFocus
        margin="none"
        name={props.name}
        value={value ?? ""}
        onChange={onChange}
        size="small"
        style={{width: '3em'}}
        error={!!error}
        title={error}
        helperText={error}
        inputProps={{
          min: 0,
          max: 100,
          step: 0.01,
          pattern: "^(0|[1-9][0-9]?)(([.])([0-9]+))?$"
        }}
      />
      %
    </>
  )
}

export default PercentInput;
